import { useState } from "react";
import { Group, Menu, Text, Modal } from "@mantine/core";
import { IconPlus, IconChevronUp } from "@tabler/icons-react";
import classes from "./Sidebar.module.css";
import useUserOrganizations from "./use-user-organizations";
import { CreateNewOrganizationForm } from "./CreateNewOrganizationForm";

const SidebarOrgSelect = () => {
  const { selectedOrganization, handleSelectChange, defineSelectData } =
    useUserOrganizations();

  const [menuOpened, setMenuOpened] = useState(false);
  const [createOrgOpened, setCreateOrgOpened] = useState(false);

  const selectedOrganizationName =
    defineSelectData().find((org) => org.value === selectedOrganization)
      ?.label || "Select an organization";

  const handleCreateOrganization = () => {
    setCreateOrgOpened(true);
    setMenuOpened(false);
  };

  return (
    <>
      <Modal
        opened={createOrgOpened}
        onClose={() => setCreateOrgOpened(false)}
        title={<strong>Create new organization</strong>}
        styles={{
          content: {
            backgroundColor: '#1a1a1a',
          },
          header: {
            backgroundColor: '#1a1a1a',
          },
        }}
      >
        <CreateNewOrganizationForm onSuccess={() => setCreateOrgOpened(false)} /> 
      </Modal>
      <Menu
        opened={menuOpened}
        onClose={() => setMenuOpened(false)}
        onOpen={() => setMenuOpened(true)}
      >
        <Menu.Target>
          <Group
            className={classes.input}
            onClick={() => setMenuOpened((o) => !o)}
          >
            <Text size="sm" className={classes.text}>
              {selectedOrganizationName}
            </Text>
            <span
              className={`${classes.icon} ${
                menuOpened ? classes.iconRotateUp : classes.iconRotateDown
              }`}
            >
              <IconChevronUp size={16} />
            </span>
          </Group>
        </Menu.Target>
        <Menu.Dropdown className={classes.dropdown}>
          {defineSelectData().map((organization) => (
            <Menu.Item
              key={organization.value}
              onClick={() => {
                handleSelectChange(organization.value);
                setMenuOpened(false);
              }}
              className={classes.item}
            >
              {organization.label}
            </Menu.Item>
          ))}
          <Menu.Divider />
          <Menu.Item
            onClick={() => {
              handleCreateOrganization();
            }}
          >
            + Create new organization
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </>
  );
};

export default SidebarOrgSelect;